export default __webpack_public_path__ + "static/layout-dont-light-ba7f073411160d56341b3ebfc8fedfd1.png";